/**
 * Theme configuration based on Design System
 */

export const colors = {
  // Primary brand colors
  primary: {
    main: '#12a4ff', // APP/AccentColor
    secondary: '#224967', // APP/AccentSecondary
    shade: '#ebf5fc', // APP/AccentShade
    logo: '#0a94f0', // APP/Logo
  },

  // Background colors
  background: {
    main: '#f6fafa', // APP/Background/BackgroundMain
    primary: '#ffffff', // APP/Background/BackgroundPrimary
    secondary: '#f6fafa', // APP/Background/BackgroundSecondary
    tertiary: '#e9edee', // APP/Background/BackgroundTertiary
    content: '#ffffff', // APP/Background/BackgroundContent
    readCell: '#e0ecf8', // APP/Background/BackgroundReadCell
    selected: '#f7fafa', // APP/Background/ListSelectedBackground
    habitSelected: '#e9e9e9', // APP/Background/HabitRowBackgroundSelected
    habitRow: '#ffffff', // APP/Background/HabitRowBackground
    input: '#888c92', // APP/Background/InputBackground
    darkHeader: '#394955', // APP/Background/BackgroundDarkHeader
    progress1: '#f3f6fc', // APP/Background/ProgressBackground1
    progress2: '#e9e9e9', // APP/Background/ProgressBackground2
    actionPlanHeader: '#5cabdf', // APP/Background/ActionPlanHeaderBackground
  },

  // Text colors
  text: {
    primary: '#23262d', // APP/Text/TextPrimary
    secondary: '#565b63', // APP/Text/TextSecondary
    tertiary: '#748088', // APP/Text/TextTertiary
    highlightBackground: '#f7ed94', // APP/Text/TextHighlightBackground
    input: '#23262d', // APP/TextInput/Text
  },

  // Button colors
  button: {
    mainText: '#ffffff', // APP/Button/ButtonMainText
    mainBackground: '#007bc7', // APP/Button/ButtonMainBackground
    disabledText: '#748088', // APP/Button/ButtonDisabledText
    disabledBackground: '#dce1e2', // APP/Button/ButtonDisabledBackground
    linkText: '#12a4ff', // APP/Button/ButtonLinkText
  },

  // Status colors
  status: {
    warning: '#f7ae6e', // APP/Statuses/WarningMain
    success: '#00bb90', // APP/Statuses/SuccessMain
    danger: '#fb7e71', // APP/Statuses/DangerMain
  },

  // MultiChoice component colors
  multiChoice: {
    background: '#ffffff', // APP/MultiChoice/MultChoice Background
    selectedBackground: '#f7fafa', // APP/MultiChoice/MultiChoicenSelectedBackground
    text: '#565b63', // APP/MultiChoice/MultiChoice text
    selectedStroke: '#12a4ff', // APP/MultiChoice/ListSelectedStroke
  },

  // Habit category colors
  habitCategory: {
    health: '#4eb96e', // APP/HabitCategory/Health
    love: '#c8655a', // APP/HabitCategory/Love
    happiness: '#c3b156', // APP/HabitCategory/Happiness
    wealth: '#4bb1b4', // APP/HabitCategory/Wealth
  },

  // Quote colors
  quote: {
    green: '#78d047', // APP/Quote/Quote_green
    yellow: '#f3cd0d', // APP/Quote/Quote_yellow
    blue: '#7599f1', // APP/Quote/Quote_blue
    red: '#f37191', // APP/Quote/Quote_red
  },

  // Rainbow palette
  rainbow: {
    r1: '#4bb1b4', // APP/Rainbow/Rainbow1
    r2: '#4cb191', // APP/Rainbow/Rainbow2
    r3: '#4eb96e', // APP/Rainbow/Rainbow3
    r4: '#57bb50', // APP/Rainbow/Rainbow4
    r5: '#81be52', // APP/Rainbow/Rainbow5
    r6: '#abc154', // APP/Rainbow/Rainbow6
    r7: '#c3b156', // APP/Rainbow/Rainbow7
    r8: '#9fb176', // APP/Rainbow/Rainbow8
    r9: '#76b197', // APP/Rainbow/Rainbow9
  },

  // Evaluation gradient colors
  evaluation: {
    gradient1: '#a80000', // APP/Evaluation/EvaluationGradient1
    gradient2: '#b79b00', // APP/Evaluation/EvaluationGradient2
    gradient3: '#00c741', // APP/Evaluation/EvaluationGradient3
  },

  // Miscellaneous colors
  misc: {
    white: '#ffffff', // APP/White
    lighter: '#ffffff', // APP/Lighter
    stars: '#e89b26', // APP/Stars
    progress: '#4285f4', // APP/Progress
    readingProgress: '#b491e8', // APP/ReadingProgress1
    paywallTable: '#bde4fb', // APP/PaywallTable
  },
};

// Common opacity values
export const opacity = {
  light: 0.5,
  medium: 0.7,
  high: 0.9,
};

// Component-specific semantic colors
export const semantic = {
  reflectionQuestion: colors.status.success,
  actionStep: colors.status.danger,
  actionButton: colors.button.mainBackground,
};

// Export default theme (currently only light theme)
export default {
  colors,
  opacity,
  semantic,
}; 